<template>
    <transition name="modal-fade">
		<div class="modal modal-mask" style="display: block">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="!practice" class="modal-title">{{ lang['stats.details_label'] }}</h5>
                        <h5 v-if="practice" class="modal-title">{{ lang['stats.practice_label'] }}</h5>
                        <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                    </div>

                    <div class="modal-body">
                        <!--<div class="prompt">{{ lang['module.editor_description'] }}</div>-->
                            <div class="statsDecisionLabel mb-3">{{ decision }}</div>

                            <template v-if="options.length > 0 && hasData">
                                <div class="flex-r mt-3 mb-3">
                                    <div class="statsSummaryCount">
                                        <div class="flex-c full-h flex-center"><div class="flex-r flex-center">{{ (statsData.allCorrectClicks || 0) + " / " + (statsData.allClicks || 0) }}</div></div>
                                    </div>
                                    <div class="statsSummaryBar statsSummaryBarOverall flex-c flex-center">
                                        <div class="black">{{ lang['stats.total_correct'] }}</div>
                                        <div class="statsBar correct"></div>
                                    </div>
                                    <div class="statsSummaryPercent statsSummaryPercentOverall">
                                        <div class="flex-c full-h flex-center"><div class="flex-r flex-center statsPercentTextOverall"></div></div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="!practice">
                                <template v-if="options.length > 0 && hasData">
                                    <div class="flex-r flex-center mt-4">
                                        <div class="statsSummaryCount"></div>
                                        <div v-if="show_only == 0" class="statsSummaryButton"><label>{{ lang['stats.correct_label'] }}</label></div>
                                        <div v-if="learner" class="statsSummaryButton"><label>{{ lang['stats.chosen_learner_label'] }}</label></div>
                                        <div v-else class="statsSummaryButton"><label>{{ lang['stats.chosen_label'] }}</label></div>
                                        <div class="statsSummaryPercent statsSummaryPercentOverall"></div>
                                    </div>
                                    <div class="mt-2 mb-3">
                                        <div id="statsSummaryContainer" class="flex-c full-w">
                                            <div v-for="option in options" class="statsSummaryRow flex-r flex-center">
                                                <div class="statsSummaryCount" :rID="option.rID">
                                                    <div v-if="show_only == 0" class="flex-c full-h flex-center"><div class="flex-r flex-center">{{ (option.clicks.correctCount || 0) + " / " + (option.clicks.totalCount || 0) }}</div></div>
                                                    <div v-else class="flex-c full-h flex-center"><div class="flex-r flex-center statCountText" :rID="option.rID">0</div></div>
                                                </div>

                                                <div v-if="show_only == 0" class="statsSummaryButton">
                                                    <div v-if="show_only == 0" class="statsOptionName clickable" v-bind:class="{ selected : selected == option.rID }" v-on:click="selectChoice(option.rID)">{{ option.rName }}</div>
                                                    <div v-else class="statsOptionName " v-bind:class="{ selected : selected == option.rID }">{{ option.rName }}</div>
                                                </div>

                                                <div class="statsSummaryBar flex-c flex-center" :rID="option.rID">
                                                    <div class="black" v-bind:class="{bold : show_only && selected == option.rID}">{{ option.rName }}</div>
                                                    <div class="statsBar" v-bind:class="{correct : selected == option.rID}"></div>
                                                </div>

                                                <div class="statsSummaryPercent">
                                                    <div class="flex-c full-h flex-center"><div class="flex-r flex-center statPercentText" :rID="option.rID"></div></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-else>
                                    <div class="flex-r full-w gray flex-center">{{ lang['stats.no_data'] }}</div>
                                </template>

                                <div v-if="!learner" class="flex-r full-w gray flex-center mt-4">There are {{problems.length}} practice problems available at this decision.</div>
                            </template>


                            <template v-if="practice">

                                <div v-if="hasProblems" class="modal-section">
                                    <div class="blue-label">{{ lang['stats.practice_settings'] }}</div>

                                    <div class="flex-r flex-space mt-3">
                                        <div v-if="has_previous" class="flex-r">
                                            <label class="switch">
                                                <input type="checkbox" v-model="show_previous">
                                                <span class="slider-switch round"></span>
                                            </label>
                                            <label class="ml-3">{{ lang['stats.show_previous'] }}</label>
                                        </div>
                                        <div v-if="has_next" class="flex-r flex-stretch flex-end">
                                            <label class="mr-3">{{ lang['stats.show_next'] }}</label>
                                            <label class="switch">
                                                <input type="checkbox" v-model="show_next">
                                                <span class="slider-switch round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="flex-r mt-3">
                                        <div class="flex-c flex-stiff flex-center mr-3">
                                            <label class="centered">{{ lang['stats.feedback_level'] }}</label>
                                            <input class="clickable" type="range" min="0" max="3" step="1" v-model="feedbackLevel">
                                        </div>
                                        <div class="prompt flex-stretch">
                                            <div class="flex-c">
                                                <div class="blue-label mb-1">{{ feedbackHeader }}</div>
                                                <div>{{ feedbackDescription }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-r flex-center mt-3">
                                        <button type="button" class="btn btn-primary" @click="beginPracticeFromForm">{{ lang['stats.practice_button'] }}</button>
                                    </div>
                                </div>

                                <div v-if="!hasProblems" class="flex-r full-w gray flex-center">{{ lang['stats.no_problems'] }}</div>
                            </template>

                        </div>

                    <div class="modal-footer">
                        <button v-if="learner" type="button" class="btn" v-bind:class="{ 'btn-primary': practice, 'btn-primary-outline' : !practice }" @click="switchToDetails">Details</button>
                        <button v-if="learner" type="button" class="btn" v-bind:class="{ 'btn-success-outline': practice, 'btn-success' : !practice }" @click="switchToPractice">Practice</button>
                        <button type="button" class="btn btn-secondary" @click="closeModal">{{ lang['button.close'] }}</button>
                    </div>

				</div>
			</div>
		</div>
	</transition>
</template>

<script>

export default {
    props: ['statsData'],
    data() {
        return {
            data: [],
            hasData: false,
            decision: "",
            nID: 0,
            options: [],
            show_next: false,
            show_previous: false,
            has_next: true,
            has_previous: false,
            show_only: 0,
            selected: 0,
            learner: false,
            feedbackLevel: 2,
            practice: false,
            problems: [],
            hasProblems: false,
            lang: lang,
            strokeColors: strokeColors,
        }
    },

    mounted() {
        this.data = this.statsData.data;
        this.hasData = (this.statsData.allClicks > 0);
        this.decision = this.statsData.text;
        this.nID = this.statsData.decisionID;
        this.options = this.statsData.children;
        this.practice = this.statsData.practice;
        this.problems = this.statsData.problems;
        this.hasProblems = (this.problems.length > 0);
        this.learner = this.statsData.learner;
        this.show_next = false;
        this.show_previous = false;
        this.has_next = (this.statsData.decision.type != "terminal");
        this.has_previous = (this.nID != 1);


        if(this.statsData.defaultSelected){
            this.selected = this.statsData.defaultSelected;
            this.show_only = this.statsData.defaultSelected;
        }
        else {
            for (let o = 0; o < this.options.length; o++) {
                if (this.selected == 0 && this.options[o].clicks != []) {
                    this.selected = this.options[o].rID;
                }
            }
        }
    },

    computed: {
        feedbackHeader: function() {
            if(+this.feedbackLevel == 0){
                return lang['assignment.no_feedback'];
            }
            else if(+this.feedbackLevel == 1){
                return lang['assignment.limited_feedback'];
            }
            else if(+this.feedbackLevel == 2){
                return lang['assignment.specific_feedback'];
            }
            else if(+this.feedbackLevel == 3){
                return lang['assignment.immediate_feedback'];
            }
            return "";
        },
        feedbackDescription: function() {
            if(+this.feedbackLevel == 0){
                return lang['assignment.no_feedback_description'];
            }
            else if(+this.feedbackLevel == 1){
                return lang['assignment.limited_feedback_description'];
            }
            else if(+this.feedbackLevel == 2){
                return lang['assignment.specific_feedback_description'];
            }
            else if(+this.feedbackLevel == 3){
                return lang['assignment.immediate_feedback_description'];
            }
            return "";
        }

    },

    updated(){
        if(this.selected != 0){
            this.selectChoice(this.selected);
        }
    },

    methods: {
        closeModal() {
            this.name = '';
            this.$emit('close');
        },

        switchToDetails() {
            this.practice = false;
        },

        switchToPractice() {
            this.practice = true;
            $(".modal-body").find(".flex-r").attr("style", "");
        },

        selectChoice(rID){
            this.selected = rID;
            let data = [];
            let dataFound = false;
            for(let i = 0; i < this.options.length; i++){
                if(this.options[i].rID == rID && this.options[i].clicks.totalCount){
                    data = this.options[i].clicks;
                    dataFound = true;
                }
            }

            let strokePercent = (Math.floor((this.statsData.allCorrectClicks / this.statsData.allClicks) * 100));
            let strokeColor = strokeColors[strokePercent];

            $(".statsSummaryBarOverall .statsBar").attr("style", "width:" + ((this.statsData.allCorrectClicks / this.statsData.allClicks) * 100) + "%; background-color:" + strokeColor + "; border-right: 2px solid " + strokeColor + ";");
            $(".statsPercentTextOverall").html(((this.statsData.allCorrectClicks / this.statsData.allClicks) * 100).toFixed(2) + "%");
            $(".statsSummaryBar:not(.statsSummaryBarOverall) .statsBar").attr("style", "width:0%;");
            $(".statPercentText:not(.statsPercentTextOverall)").html("0%");
            if(dataFound){
                let totalCount = data.totalCount;
                for(let c = 0; c < data.choiceCounts.length; c++){
                    if(data.choiceCounts[c]){
                        let percent = ((data.choiceCounts[c] / totalCount) * 100).toFixed(2);
                        $(".statsSummaryBar[rID="+c+"] .statsBar").attr("style", "width:"+ percent + "%;");
                        $(".statPercentText[rID="+c+"]").html(percent + "%");
                        if(this.show_only){
                            $(".statCountText[rID="+c+"]").html(data.choiceCounts[c]);
                        }
                    }
                }
            }

        },
        beginPracticeFromForm(){
            dbPreferences.practice.includePrevious = this.show_previous;
            dbPreferences.practice.includeNext = this.show_next;
            dbPreferences.practice.feedback = +this.feedbackLevel;
            feedbackLevel = +this.feedbackLevel;
            this.closeModal();
            beginPractice(this.nID);
        },

        removeItem() {
            // const { decisionID:decision_id, modelID:model_id } = this.moduleData;
            //
            // $.post('/modules/remove', {decision_id, model_id},
            // res => {
            //     if(res != 'error') {
            //         dbNodes[decision_id] && Object.assign(dbNodes[decision_id], {module: null, module_id: 0, prompt: "",  module_name: null});
            //         $(".nodeID" + decision_id).remove();
            //         this.closeModal();
            //         undoEditSave();
            //     }
            // });
        },
    }
}

</script>
